module.exports = __webpack_public_path__ + "img/submit-work.5b29e9da.png";